<template>
  <div>
    <div class="intro-y flex flex-col sm:flex-row items-center mt-8">
      <h2 class="text-lg font-medium mr-auto">Size Wise - Group Summary</h2>
      <div class="w-full sm:w-auto flex mt-4 sm:mt-0"></div>
    </div>
    <!-- BEGIN: HTML Table Data -->
    <div class="intro-y box p-5 mt-5">
      <span tabindex="1"></span>
      <div class="grid grid-cols-12 gap-x-5">
        <div class="col-span-6 sm:col-span-3 md:col-span-2">
          <div class="">
            <label for="update-profile-form-8" class="form-label py-1"
              >Report Type</label
            >
            <select
              id="select-type"
              ref="selectType"
              tabindex="2"
              class="form-select"
              v-model="filter.report_type"
            >
              <option value="1">Planning Stock</option>
              <option value="2">Polish Stock</option>
              <option value="3">Department Planning Stock</option>
              <option value="4">Department Polish Stock</option>
            </select>
          </div>
        </div>
        <div class="col-span-6 sm:col-span-3 md:col-span-2">
          <div class="">
            <label for="update-profile-form-8" class="form-label py-1"
              >Data Type</label
            >
            <select
              id="select-type"
              ref="selectType"
              tabindex="2"
              class="form-select"
              v-model="filter.data_type"
            >
              <option value="1">Current Pieces</option>
              <option value="2">Current Weight</option>
              <option value="3">Pieces + Weight</option
              >
            </select>
          </div>
        </div>
        <div class="col-span-6 sm:col-span-3 md:col-span-2">
          <div class="">
            <label for="update-profile-form-8" class="form-label py-1"
              >Parameters</label
            >
            <select
              id="select-type"
              ref="selectType"
              tabindex="2"
              class="form-select"
              v-model="filter.parameters"
            >
              <option value="1">Shape</option>
              <option value="2">Sahpe + Purity</option>
              <option value="3">Sahpe + Color</option
              >
            </select>
          </div>
        </div>
        <div class="col-span-6 sm:col-span-3 md:col-span-3">
          <div class="">
            <label for="update-profile-form-8" class="form-label py-1"
              >Select Kapan</label
            >
                  <TomSelect v-model="filter.kapan_ids" :options="{
                placeholder: 'Select Kapan',
                loadingClass: 'loading',
                plugins: {
                  dropdown_header: {
                    title: 'Process'
                  }
                }
              }" class="w-full" multiple>
                      <option v-for="item in page_data.lot_items" :key="item.id" :value="item.id">{{item.lot_no}} ( {{ item.voucher_no ? item.voucher_no : '-' }} )</option>
                  </TomSelect>
          </div>
        </div>
        <div class="col-span-12 sm:col-span-4 md:col-span-3">
          <div class="">
            <label for="update-profile-form-6" class="form-label py-1"
              >Select Shape</label
            >
            <TomSelect
              v-model="filter.shape_ids"
              :options="{
                placeholder: 'Select Shape',
                loadingClass: 'loading',
                plugins: {
                  dropdown_header: {
                    title: 'Shape'
                  }
                }
              }"
              multiple
              class="w-full"
            >
              <option value="">Select Shape</option>
              <option
                v-for="item in page_data.shape_list"
                :key="item.id"
                :value="item.id"
                >{{ item.shape_name }}</option
              >
            </TomSelect>
          </div>
        </div>
        <div class="col-span-12 sm:col-span-4 md:col-span-3">
          <div class="">
            <label for="update-profile-form-6" class="form-label py-1"
              >Select Color</label
            >
            <TomSelect
              v-model="filter.color_ids"
              :options="{
                placeholder: 'Select Color',
                loadingClass: 'loading',
                plugins: {
                  dropdown_header: {
                    title: 'Color'
                  }
                }
              }"
              multiple
              class="w-full"
            >
              <option value="">Select Color</option>
              <option
                v-for="item in page_data.color_list"
                :key="item.id"
                :value="item.id"
                >{{ item.color_name }}</option
              >
            </TomSelect>
          </div>
        </div>
        <div class="col-span-6 sm:col-span-4 md:col-span-3">
          <div class="">
            <label for="update-profile-form-6" class="form-label py-1"
              >Select Purity</label
            >
            <TomSelect
              v-model="filter.purity_ids"
              :options="{
                placeholder: 'Select Purity',
                loadingClass: 'loading',
                plugins: {
                  dropdown_header: {
                    title: 'Purity'
                  }
                }
              }"
              multiple
              class="w-full"
            >
              <option value="">Select Purity</option>
              <option
                v-for="item in page_data.purity_list"
                :key="item.id"
                :value="item.id"
                >{{ item.purity_name }}</option
              >
            </TomSelect>
          </div>
        </div>
        <div class="col-span-6 sm:col-span-3 md:col-span-2">
          <div class="">
            <label for="update-profile-form-6" class="form-label py-1"
              >Stone Type</label
            >
            <TomSelect
              v-model="filter.stone_type"
              :options="{
                placeholder: 'Stone  Type',
                loadingClass: 'loading',
                plugins: {
                  dropdown_header: {
                    title: 'Type'
                  }
                }
              }"
              multiple
              class="w-full"
            >
              <option value="">Select Type</option>
              <option
                v-for="item in page_data.stone_list"
                :key="item.id"
                :value="item.id"
                >{{ item.stone_name }}</option
              >
            </TomSelect>
          </div>
        </div>
        <div class="col-span-6 sm:col-span-4 md:col-span-3">
          <div class="mt-9">
            <button
              id="tabulator-html-filter-go"
              type="button"
              class="btn btn-primary w-full sm:w-20 mx-2"
              tabindex="5"
              @click="generateReport()"
            >
              Generate
            </button>
            <button
              id="tabulator-html-filter-reset"
              type="button"
              class="btn btn-secondary w-full sm:w-16 mt-2 sm:mt-0 sm:ml-1 mx-2"
              tabindex="6"
              @click="onResetFilter"
            >
              Reset
            </button>
            <button
            v-if="
            page_data.generate == 'gen' && page_data.charni_header.length > 0
          "
              id="tabulator-html-filter-go"
              type="button"
              class="btn btn-primary w-full sm:w-20 ml-4 mx-2"
              @click="exportReportDetails"
            >
              Export
            </button>
          </div>
        </div>
      </div>

      <div id="responsive-table" class="p-5" v-if="loading">
        <div class="preview">
          <div class="overflow-x-auto">
            <div
              class="col-span-6 sm:col-span-3 xl:col-span-2 flex flex-col justify-end items-center"
            >
              <LoadingIcon icon="bars" class="w-8 h-8" />
              <div class="text-center text-xs mt-2">Getting Latest Price</div>
            </div>
          </div>
        </div>
      </div>

      <div v-else>
        <div
          class="overflow-x-auto scrollbar-hidden"
          v-if="page_data.generate == 'gen'"
        >
          <div id="generate-pdf" class="p-5">
            <div class="preview">
              <div class="overflow-x-auto">
                <table class="w-full" v-if="export_filter.report_type == 1 || export_filter.report_type == 2">
                  <thead>
                    <tr>
                      <th class="border-t-2 border-b-2 border-l-2 border-r-2 text-center bg-gray-200  dark:border-dark-5 whitespace-nowrap"></th>
                      <th
                        class="border-t-2 border-b-2 border-l-2 border-r-2 text-center bg-gray-200  dark:border-dark-5 whitespace-nowrap"
                        :colspan="export_filter.data_type == 3 ? (page_data.charni_header_2.length - 1) : (page_data.charni_header.length - 1)"
                      >
                        Size
                      </th>
                    </tr>
                    <tr>
                      <th :colspan="page_data.charni_header_cols[index]"
                        class="border-t-2 border-b-2 border-l-2 border-r-2 text-center bg-gray-200  dark:border-dark-5 whitespace-nowrap"
                        v-for="(record, index) in page_data.charni_header" :key="index"
                      >
                        {{record}}
                      </th>
                    </tr>
                    <tr v-if="export_filter.parameters == 2 || export_filter.parameters == 3">
                      <th
                        class="border-t-2 border-b-2 border-l-2 border-r-2 text-center bg-gray-200  dark:border-dark-5 whitespace-nowrap"
                        v-for="(record, index) in page_data.charni_header_2" :key="index" :colspan="export_filter.data_type == 3 ? 2 : 1"
                      >
                        {{record}}
                      </th>
                    </tr>
                    <tr v-if="export_filter.data_type == 3">
                      <th
                        class="border-t-2 border-b-2 border-l-2 border-r-2 text-center bg-gray-200  dark:border-dark-5 whitespace-nowrap"
                        v-for="(record, index) in page_data.charni_header_3" :key="index"
                      >
                        {{record}}
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr v-for="record in page_data.return_data" :key="record" class="hover:bg-gray-200">
                      <td
                        class="border-b border-l border-r text-center whitespace-nowrap"
                        v-for="(value, index) in record"
                        :key="index"
                      >
                        <span class="">{{ value }}</span>
                        <!-- <span v-else>{{value > 0 ? $h.myFloat(value) : '0'}}</span> -->
                      </td>
                    </tr>
                    <tr
                      class="bg-gray-200  dark:border-dark-5 whitespace-nowrap"
                    >
                      <td
                        class="border-b border-l border-r text-center whitespace-nowrap font-bold px-2"
                        v-for="(record, index) in page_data.footer_arr"
                        :key="index"
                      >
                        <span class="font-bold">{{ record }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <!-- <table class="w-full" v-if="export_filter.report_type == 1 || export_filter.report_type == 2">
                  <thead>
                    <tr>
                      <th class="border-t-2 border-b-2 border-l-2 border-r-2 text-center bg-gray-200  dark:border-dark-5 whitespace-nowrap"></th>
                      <th
                        class="border-t-2 border-b-2 border-l-2 border-r-2 text-center bg-gray-200  dark:border-dark-5 whitespace-nowrap"
                        :colspan="export_filter.data_type == 3 ? (page_data.charni_header_2.length - 1) : (page_data.charni_header.length - 1)"
                      >
                        Size
                      </th>
                    </tr>
                    <tr>
                      <th :colspan="((index > 1 && export_filter.data_type == 3)  ? 2 : 1)"
                        class="border-t-2 border-b-2 border-l-2 border-r-2 text-center bg-gray-200  dark:border-dark-5 whitespace-nowrap"
                        v-for="(record, index) in page_data.charni_header"
                      >
                        {{record}}
                      </th>
                    </tr>
                    <tr v-if="export_filter.data_type == 3">
                      <th
                        class="border-t-2 border-b-2 border-l-2 border-r-2 text-center bg-gray-200  dark:border-dark-5 whitespace-nowrap"
                        v-for="(record, index) in page_data.charni_header_2"
                      >
                        {{record}}
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr v-for="record in page_data.return_data" :key="record" class="hover:bg-gray-200">
                      <td
                        class="border-b border-l border-r text-center whitespace-nowrap"
                        v-for="(value, index) in record"
                        :key="value"
                      >
                        <span class="">{{ value }}</span>
                      </td>
                    </tr>
                    <tr
                      class="bg-gray-200  dark:border-dark-5 whitespace-nowrap"
                    >
                      <td
                        class="border-b border-l border-r text-center whitespace-nowrap font-bold"
                        v-for="(record, index) in page_data.footer_arr"
                        :key="index"
                      >
                        <span class="font-bold">{{ record }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table> -->
                <table class="w-full" v-if="export_filter.report_type == 3 || export_filter.report_type == 4">
                  <thead>
                  <tr class="border-b bg-gray-300 dark:bg-dark-1">
                    <th class="py-2 text-xs lg:text-md whitespace-nowrap">#</th>
                    <th class="py-2 text-xs lg:text-md whitespace-nowrap">
                      MANAGER / Party
                    </th>
                    <th class="py-2 text-xs lg:text-md whitespace-nowrap">
                      Department
                    </th>
                    <th class="py-2 text-xs lg:text-md whitespace-nowrap">
                      AVAILABLE TOTAL PCS
                    </th>
                    <th class="py-2 text-xs lg:text-md whitespace-nowrap">
                      AVAILABLE ROUGH CT
                    </th>
                    <th class="py-2 text-xs lg:text-md whitespace-nowrap">
                      AVAILABLE CURRENT CT
                    </th>
                    <th class="py-2 text-xs lg:text-md whitespace-nowrap">
                      PROCESS TOTAL PCS
                    </th>
                    <th class="py-2 text-xs lg:text-md whitespace-nowrap">
                      PROCESS ROUGH CT
                    </th>
                    <th class="py-2 text-xs lg:text-md whitespace-nowrap">
                      PROCESS CURRENT CT
                    </th>
                    <th class="py-2 text-xs lg:text-md whitespace-nowrap">
                      TOTAL PCS
                    </th>
                    <th class="py-2 text-xs lg:text-md whitespace-nowrap">
                      TOTAL ROUGH CT
                    </th>
                    <th class="py-2 text-xs lg:text-md whitespace-nowrap">
                      TOTAL CURRENT CT
                    </th>
                  </tr>
                  <tr class="border-b bg-gray-200 dark:bg-dark-1">
                    <td class="py-2 border-b text-xs lg:text-md whitespace-nowrap text-center border-r">TOTAL</td>
                    <td class="py-2 border-b text-xs lg:text-md whitespace-nowrap text-center border-r">{{ page_data.total?.manager_name ?? ""}}</td>
                    <td class="py-2 border-b text-xs lg:text-md whitespace-nowrap text-center border-r">{{ page_data.total?.department_name ?? ""}}</td>
                    <td class="py-2 border-b text-xs lg:text-md whitespace-nowrap text-center border-r">{{ page_data.total?.total_available_pieces ?? ""}}</td>
                    <td class="py-2 border-b text-xs lg:text-md whitespace-nowrap text-center border-r">{{ page_data.total?.total_available_rough_weight ?? 0}}</td>
                    <td class="py-2 border-b text-xs lg:text-md whitespace-nowrap text-center border-r">{{ page_data.total?.total_available_current_weight ?? 0}}</td>
                    <td class="py-2 border-b text-xs lg:text-md whitespace-nowrap text-center border-r">{{ page_data.total?.total_process_pieces ?? ""}}</td>
                    <td class="py-2 border-b text-xs lg:text-md whitespace-nowrap text-center border-r">{{ page_data.total?.total_process_rough_weight ?? 0}}</td>
                    <td class="py-2 border-b text-xs lg:text-md whitespace-nowrap text-center border-r">{{ page_data.total?.total_process_current_weight ?? 0}}</td>
                    <td class="py-2 border-b text-xs lg:text-md whitespace-nowrap text-center border-r">{{ page_data.total?.total_pieces ?? ""}}</td>
                    <td class="py-2 border-b text-xs lg:text-md whitespace-nowrap text-center border-r">{{ page_data.total?.total_rough_weight ?? 0}}</td>
                    <td class="py-2 border-b text-xs lg:text-md whitespace-nowrap text-center border-r">{{ page_data.total?.total_current_weight ?? 0}}</td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in page_data.data" :key="index">
                    <td class="py-2 border-b text-xs lg:text-md whitespace-nowrap text-center border-r">{{ index + 1 }}</td>
                    <td class="py-2 border-b text-xs lg:text-md whitespace-nowrap text-center border-r">{{ item.manager_name}}</td>
                    <td class="py-2 border-b text-xs lg:text-md whitespace-nowrap text-center border-r">{{ item.department_name}}</td>
                    <td class="py-2 border-b text-xs lg:text-md whitespace-nowrap text-center border-r">{{ item.total_available_pieces ?? ""}}</td>
                    <td class="py-2 border-b text-xs lg:text-md whitespace-nowrap text-center border-r">{{ item.total_available_rough_weight ?? 0}}</td>
                    <td class="py-2 border-b text-xs lg:text-md whitespace-nowrap text-center border-r">{{ item.total_available_current_weight ?? 0}}</td>
                    <td class="py-2 border-b text-xs lg:text-md whitespace-nowrap text-center border-r">{{ item.total_process_pieces ?? ""}}</td>
                    <td class="py-2 border-b text-xs lg:text-md whitespace-nowrap text-center border-r">{{ item.total_process_rough_weight ?? 0}}</td>
                    <td class="py-2 border-b text-xs lg:text-md whitespace-nowrap text-center border-r">{{ item.total_process_current_weight ?? 0}}</td>
                    <td class="py-2 border-b text-xs lg:text-md whitespace-nowrap text-center border-r">{{ item.total_pieces ?? ""}}</td>
                    <td class="py-2 border-b text-xs lg:text-md whitespace-nowrap text-center border-r">{{ item.total_rough_weight ?? 0}}</td>
                    <td class="py-2 border-b text-xs lg:text-md whitespace-nowrap text-center border-r">{{ item.total_current_weight ?? 0}}</td>
                  </tr>
                  <tr class="border-b bg-gray-200 dark:bg-dark-1">
                    <td class="py-2 border-b text-xs lg:text-md whitespace-nowrap text-center border-r">TOTAL</td>
                    <td class="py-2 border-b text-xs lg:text-md whitespace-nowrap text-center border-r">{{ page_data.total?.manager_name ?? ""}}</td>
                    <td class="py-2 border-b text-xs lg:text-md whitespace-nowrap text-center border-r">{{ page_data.total?.department_name ?? ""}}</td>
                    <td class="py-2 border-b text-xs lg:text-md whitespace-nowrap text-center border-r">{{ page_data.total?.total_available_pieces ?? ""}}</td>
                    <td class="py-2 border-b text-xs lg:text-md whitespace-nowrap text-center border-r">{{ page_data.total?.total_available_current_weight ?? 0}}</td>
                    <td class="py-2 border-b text-xs lg:text-md whitespace-nowrap text-center border-r">{{ page_data.total?.total_available_rough_weight ?? 0}}</td>
                    <td class="py-2 border-b text-xs lg:text-md whitespace-nowrap text-center border-r">{{ page_data.total?.total_process_pieces ?? ""}}</td>
                    <td class="py-2 border-b text-xs lg:text-md whitespace-nowrap text-center border-r">{{ page_data.total?.total_process_rough_weight ?? 0}}</td>
                    <td class="py-2 border-b text-xs lg:text-md whitespace-nowrap text-center border-r">{{ page_data.total?.total_process_current_weight ?? 0}}</td>
                    <td class="py-2 border-b text-xs lg:text-md whitespace-nowrap text-center border-r">{{ page_data.total?.total_pieces ?? ""}}</td>
                    <td class="py-2 border-b text-xs lg:text-md whitespace-nowrap text-center border-r">{{ page_data.total?.total_rough_weight ?? 0}}</td>
                    <td class="py-2 border-b text-xs lg:text-md whitespace-nowrap text-center border-r">{{ page_data.total?.total_current_weight ?? 0}}</td>
                  </tr>
                </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END: HTML Table Data -->
  </div>
</template>

<script>
import { defineComponent, inject, ref, reactive, onMounted } from 'vue'
import { BASE_URL } from '@/constants/config.js'
import FileDownload from 'js-file-download'

export default defineComponent({
  setup() {
    const loading = ref(false)
    const swal = inject('$swal')
    const filter = reactive({
      report_type: 1,
      data_type: 1,
      parameters: 1,
      kapan_ids: [],
      color_ids: [],
      shape_ids: [],
      stone_type: [],
      purity_ids: [],
      lab: 'all',
      department_ids: [],
      jangad_no : [],
    })
    const export_filter = reactive({
      report_type: 1,
      data_type: 1,
      parameters: 1,
      kapan_ids: [],
      color_ids: [],
      shape_ids: [],
      stone_type: [],
      purity_ids: [],
      lab: 'all',
      department_ids: [],
      jangad_no : [],
    })
    const page_data = reactive({
      generate: 'no',
      data: [],
      total: null,
      color_list: [],
      stone_list: [],
      purity_list: [],
      shape_list: [],
      department_list: [],
      charni_header: [],
      charni_header_2: [],
      charni_header_3: [],
      charni_header_cols: [],
      footer_arr: [],
      jangad_items: [],
      return_data: []
    })

    const getParameters = () => {
      getColorList()
      getShapeList()
      getPurityList()
      getStoneList()
      getLotDetails()
      getDepartmentList()
    }

    // Get Color List
    const getColorList = () => {
      let _this = this
      const params = {}
      let promise = axios({
        url: 'api/master/dp_color',
        method: 'POST',
        params: params,
        baseURL: BASE_URL,
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
        config: { headers: { Accept: 'application/json' } }
      })
      return promise
        .then(result => result.data)
        .then(data => {
          page_data.color_list = data.items
        })
        .catch(_error => {
          page_data.color_list = []
        })
    }
    const getShapeList = () => {
      let _this = this
      const params = {}
      let promise = axios({
        url: 'api/master/dp_shape',
        method: 'POST',
        params: params,
        baseURL: BASE_URL,
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
        config: { headers: { Accept: 'application/json' } }
      })
      return promise
        .then(result => result.data)
        .then(data => {
          page_data.shape_list = data.items
        })
        .catch(_error => {
          page_data.shape_list = []
        })
    }
    // Get Purity List
    const getPurityList = () => {
      let _this = this
      const params = {}
      let promise = axios({
        url: 'api/master/dp_purity',
        method: 'POST',
        params: params,
        baseURL: BASE_URL,
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
        config: { headers: { Accept: 'application/json' } }
      })
      return promise
        .then(result => result.data)
        .then(data => {
          page_data.purity_list = data.items
        })
        .catch(_error => {
          page_data.purity_list = []
        })
    }
    // Get Purity List
    const getStoneList = () => {
      let _this = this
      const params = {}
      let promise = axios({
        url: 'api/master/dp_stone',
        method: 'POST',
        params: params,
        baseURL: BASE_URL,
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
        config: { headers: { Accept: 'application/json' } }
      })
      return promise
        .then(result => result.data)
        .then(data => {
          page_data.stone_list = data.items
        })
        .catch(_error => {
          page_data.stone_list = []
        })
    }
    // Get Department List
    const getDepartmentList = () => {
      let _this = this
      const params = {}
      let promise = axios({
        url: 'api/master/dp_department',
        method: 'POST',
        params: params,
        baseURL: BASE_URL,
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
        config: { headers: { Accept: 'application/json' } }
      })
      return promise
        .then(result => result.data)
        .then(data => {
          page_data.department_list = data.items
        })
        .catch(_error => {
          page_data.department_list = []
        })
    }

    const getLotDetails = async () => {
        let params = {
        }
        let api_url = 'api/master/dp_lot_all_details'

        let promise = axios({
            url: api_url,
            method: "post",
            data: params,
            baseURL: BASE_URL,
            headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),

            },
            config: {
                headers: {
                    Accept: "application/json"
                }
            }
        });
        return promise
            .then(result => result.data)
            .then(data => {
                page_data.lot_items = data.items
            })
            .catch(_error => {
                page_data.lot_items = []
            });
    }

    // Generate Report
    const generateReport = () => {
      export_filter.report_type = filter.report_type
      export_filter.jangad_no = filter.jangad_no
      export_filter.data_type = filter.data_type
      export_filter.parameters = filter.parameters
      export_filter.kapan_ids = (filter.kapan_ids.length == 0 ? "" : filter.kapan_ids)
      export_filter.shape_ids = (filter.shape_ids.length == 0 ? "" : filter.shape_ids)
      export_filter.color_ids = (filter.color_ids.length == 0 ? "" : filter.color_ids)
      export_filter.purity_ids = (filter.purity_ids.length == 0 ? "" : filter.purity_ids)
      export_filter.stone_type = (filter.stone_type.length == 0 ? "" : filter.stone_type)
      export_filter.lab = filter.lab
      export_filter.department_ids = (filter.department_ids.length == 0 ? "" : filter.department_ids)

      loading.value = true
      page_data.generate = 'no'

      page_data.charni_header = []
      page_data.charni_header_2 = []
      page_data.footer_arr = []
      page_data.return_data = []

      let promise = axios({
        url: 'api/report/charni-report',
        method: 'POST',
        data: export_filter,
        baseURL: BASE_URL,
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
        config: { headers: { Accept: 'application/json' } }
      })
      return promise
        .then(result => result.data)
        .then(data => {
          loading.value = false
          if (data.status == false) {
            swal('Warning', data.message, 'warning')

            page_data.data = []
            page_data.total = null
            page_data.charni_header = []
            page_data.charni_header_2 = []
            page_data.footer_arr = []
            page_data.return_data = []
          } else {

            page_data.generate = 'gen'
            if(export_filter.report_type == 1 || export_filter.report_type == 2) {

              page_data.charni_header = data.charni_header
              page_data.charni_header_2 = data.charni_header_2
              page_data.charni_header_3 = data.charni_header_3
              page_data.charni_header_cols = data.charni_header_cols
              page_data.footer_arr = data.footer_arr
              page_data.return_data = data.return_data
            } else if(export_filter.report_type == 3 || export_filter.report_type == 4) {

              page_data.data = data.items
              page_data.total = data.total
            }
          }
        })
        .catch(_error => {
          loading.value = false
          page_data.generate = 'no'
        })
    }

    function exportReportDetails() {
      const today = new Date()
      const date =
        today.getDate() + '' + (today.getMonth() + 1) + '' + today.getFullYear()
      // const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      const dateTime = date
      let filename = 'SIZE_WISE_STOCK_' + dateTime + '.xlsx'

      let promise = axios({
        url: '/api/report/charni-report-export',
        method: 'post',
        data: {
          charni_header: page_data.charni_header,
          charni_header_2: page_data.charni_header_2,
          charni_header_3: page_data.charni_header_3,
          charni_header_cols: page_data.charni_header_cols,
          footer_arr: page_data.footer_arr,
          return_data: page_data.return_data,
          export_filter: export_filter,
        },
        baseURL: BASE_URL,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        },
        config: {
          headers: {
            Accept: 'application/json'
          }
        },
        responseType: 'blob'
      })

      return promise
        .then(result => result.data)
        .then(data => {
          FileDownload(data, filename)
        })
        .catch(_error => {
          return []
        })
    }

    const onResetFilter = () => {
      filter.report_type = 1
      filter.data_type = 1
      filter.color_ids = []
      filter.purity_ids = []
      filter.stone_type = []
      filter.lab = 'all'
      filter.department_ids = []
    }

    onMounted(() => {
      getParameters()
    })

    return {
      loading,
      filter,
      export_filter,
      page_data,
      generateReport,
      exportReportDetails,
      onResetFilter
    }
  }
})
</script>
